module.exports = __webpack_public_path__ + "static/media/resource-misc.75c276b0.png";